module.exports = __webpack_public_path__ + "static/img/tjsp3.3a5ea53.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/newestqianniu/tjsp3.png
// module id = 390
// module chunks = 0